import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
// Next we make an 'axiosConfigDotNet' of it
const axiosConfigDotNet = axios.create({
// .. where we make our configurations
    //baseURL: 'https://localhost:7151/api'
    baseURL: 'https://api.bscl.gov.bd:5001/api'
    //baseURL: 'https://api.mirror.tvr.bscl.gov.bd:5001/api'

});

// Where you would set stuff like your 'Authorization' header, etc ...
//axiosConfigDotNet.defaults.headers.common['Authorization'] = localStorage.getItem("_authToken");

// Also add/ configure interceptors && all the other cool stuff

axiosConfigDotNet.interceptors.request.use(function (config) {
  //const cookies = new Cookies();
    // Do something before request is sent
    config.headers.common['Authorization'] =cookies.get('_authToken');//  localStorage.getItem("_authToken");
    //this.$Progress.start(); 
    //console.log("intercepted");
    return config;
  }, function (error) {
    
    // Do something with request error
    return Promise.reject(error);
  });
axiosConfigDotNet.interceptors.response.use(function (response) {
  //const cookies = new Cookies();
  //console.log('request interceptor good');
  return response;
}, function(error) {

  //console.log('request interceptor bad');

  //console.log(error.response.status);
 if (error.response.status === 401) {
  //console.log("kkk");
  //localStorage.clear();
  cookies.remove('_authToken');
            cookies.remove('_role');
            cookies.remove('username');
      window.location.href="/";
 }
 return Promise.reject(error)
});


export default axiosConfigDotNet;
